import { createHead } from '@unhead/vue/client'
import { defineVuePlugin } from '#/vue-plugins'

import { getAppConfig } from '@/shared/lib/tenant'

export default defineVuePlugin((app) => {
  const head = createHead()
  app.use(head)

  // Получаем конфигурацию и устанавливаем favicon и title
  try {
    const config = getAppConfig(app)

    head.push({
      title: config.title.default,
      titleTemplate: (title) => {
        return title === config.title.default ? title : `${title}${config.title.suffix}`
      },
      link: [
        {
          rel: 'icon',
          type: config.favicon.type,
          href: config.favicon.path,
        },
      ],
    })
  } catch (error) {
    console.warn('Failed to set favicon and title from config:', error)
  }
})
